module.exports = __webpack_public_path__ + "static/media/kda3.b7e8f7aa.jpeg";